import * as yup from "yup";
import CONFIG_VALUES from ".";

const environmentVariablesSchema = yup.object().shape({
  APP_ENV: yup
    .string()
    .oneOf(["development", "staging", "production"])
    .default("development"),
  SITE_URL: yup.string().required(),
  HOST_API: yup.string().required(),
});

export function validateEnvironmentVariables() {
  environmentVariablesSchema
    .validate(
      Object.fromEntries(
        Object.keys(CONFIG_VALUES).map((key) => [
          key,
          CONFIG_VALUES[key as keyof typeof CONFIG_VALUES],
        ]),
      ),
      {
        abortEarly: false,
      },
    )
    .catch(function (err: yup.ValidationError) {
      throw new Error(
        `Please set the following environment variables: ${err.errors.join(
          ", ",
        )}`,
      );
    });
}
